import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
  'data-ffid'?: string;
};

const Icon: React.FC<Props> = ({ className = '', dimension = 24, 'data-ffid': dataFfid }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={dimension}
    height={dimension}
    viewBox="0 0 32 32"
    aria-hidden="true"
    className={className}
    data-ffid={dataFfid}
  >
    <circle cx="16" cy="16" r="16" fill="currentColor" />
  </svg>
);

export default Icon;
